import { setSafe } from "../../util/storeHelper";
import * as actions from "./actions";
/**
 * reducer for changes to interface settings
 */
const settingsReducer = {
    reducers: {
        [actions.completeStep]: (state, payload) => setSafe(state, ["steps", payload], true),
        [actions.resetSteps]: (state) => setSafe(state, ["steps"], {}),
    },
    defaults: {
        steps: {},
    },
};
export default settingsReducer;
